import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const basename = process.env.REACT_APP_BASENAME || '';


  useEffect(() => {
    checkLoggedIn();
  }, []);

  const checkLoggedIn = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await api.get(`/auth/me`);
        setUser(res.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
        localStorage.removeItem('token');
        setUser(null);
      }
    } else {
      setUser(null);
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    try {
      const res = await api.post(`/auth/login`, { email, password });
      localStorage.setItem('token', res.data.token);
      setUser(res.data.user);
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const register = async (email, password, username) => {
    const res = await api.post(`/auth/register`, { email, password, username });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    //navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, register, loading, checkLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);